"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateSubCategory = exports.savePreferences = exports.togglePreference = exports.toggleAllPreference = exports.loadMyPreferences = exports.fetchMyPreferences = exports.fetchOptions = void 0;
var preferences_1 = require("@pbl/pbl-react-core/lib/models/preferences");
var services_1 = require("@pbl/pbl-react-core/lib/services");
var lodash_1 = __importDefault(require("lodash"));
var constants_1 = __importDefault(require("../../../config/constants"));
var actions_1 = require("../../../redux/reducers/app/actions");
var fetchOptions = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, dispatch({
                        type: preferences_1.PREFERENCES_FETCH_OPTIONS,
                        payload: services_1.PreferencesService.fetchOptions()
                    })];
            case 1:
                _a.sent();
                return [3, 3];
            case 2:
                e_1 = _a.sent();
                dispatch((0, actions_1.showMessageBar)({ message: e_1.payload.error, type: 'error' }));
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.fetchOptions = fetchOptions;
var fetchMyPreferences = function () { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var account, uid, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch((0, actions_1.clearMessages)());
                account = getState().authentication.account;
                uid = account ? account.login : '';
                return [4, dispatch({
                        type: preferences_1.PREFERENCES_FETCH,
                        payload: services_1.PreferencesService.fetch(uid)
                    })];
            case 1:
                _a.sent();
                return [3, 3];
            case 2:
                e_2 = _a.sent();
                dispatch((0, actions_1.showMessageBar)({ message: e_2.payload.error, type: 'error' }));
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.fetchMyPreferences = fetchMyPreferences;
var loadMyPreferences = function () { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var preferences, filteredPrefs;
    return __generator(this, function (_a) {
        try {
            preferences = getState().preferences;
            filteredPrefs = lodash_1.default.filter(preferences.categories, function (cat) {
                if (cat.subCategories && cat.subCategories.length > 0) {
                    cat.subCategories = lodash_1.default.filter(cat.subCategories, function (subCat) { return subCat.channel === 'EMAIL' || subCat.channel === 'OMNI'; });
                }
                cat['mainCat'] = true;
                if (cat.channel === 'EMAIL' || cat.channel === 'OMNI')
                    return cat;
            });
            dispatch({
                type: preferences_1.PREFERENCES_LOAD,
                payload: filteredPrefs || {}
            });
        }
        catch (e) {
            dispatch((0, actions_1.showMessageBar)({ message: e.payload.error, type: 'error' }));
        }
        return [2];
    });
}); }; };
exports.loadMyPreferences = loadMyPreferences;
var toggleAllPreference = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        dispatch({
            type: preferences_1.PREFERENCES_TOGGLE_ALL
        });
        return [2];
    });
}); }; };
exports.toggleAllPreference = toggleAllPreference;
var togglePreference = function (pref) { return function (dispatch) {
    dispatch({
        type: preferences_1.PREFERENCES_TOGGLE,
        payload: pref
    });
}; };
exports.togglePreference = togglePreference;
var flattenCategories = function (list) {
    return lodash_1.default.reduce(list, function (result, current) {
        var parent = {
            key: current.key,
            tag: current.tag,
            channel: current.channel,
            booleanValue: current.booleanValue || false,
            value: current.value,
            options: current.options
        };
        var subCategories = lodash_1.default.map(current.subCategories || [], function (_a) {
            var key = _a.key, tag = _a.tag, channel = _a.channel, booleanValue = _a.booleanValue, value = _a.value, options = _a.options;
            return ({
                key: key,
                tag: tag,
                channel: channel,
                booleanValue: booleanValue || false,
                value: value,
                options: options
            });
        });
        return __spreadArray(__spreadArray(__spreadArray([], result, true), [parent], false), subCategories, true);
    }, []);
};
var savePreferences = function () { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, account, tempState, formCategories, e_3;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                dispatch((0, actions_1.clearMessages)());
                _a = getState(), account = _a.authentication.account, tempState = _a.preferences.tempState;
                if (!!lodash_1.default.isEmpty(account)) return [3, 2];
                formCategories = flattenCategories(tempState.categories);
                return [4, dispatch({
                        type: preferences_1.PREFERENCES_SAVE,
                        payload: services_1.PreferencesService.savePreferences(formCategories)
                    })];
            case 1:
                _b.sent();
                dispatch((0, actions_1.showMessageBar)({
                    message: 'preferences.updated',
                    messageTimeout: constants_1.default.PREFERENCES_MESSAGE_BAR_TIMEOUT_IN_MILLISECONDS
                }));
                _b.label = 2;
            case 2: return [3, 4];
            case 3:
                e_3 = _b.sent();
                dispatch((0, actions_1.showMessageBar)({ message: e_3.payload.error, type: 'error' }));
                return [3, 4];
            case 4: return [2];
        }
    });
}); }; };
exports.savePreferences = savePreferences;
var updateSubCategory = function (category) { return function (dispatch) {
    dispatch({
        type: preferences_1.PREFERENCES_UPDATE_SUB_CATEGORY,
        payload: category
    });
}; };
exports.updateSubCategory = updateSubCategory;
//# sourceMappingURL=actions.js.map